import React, { useState } from 'react';
import { DatePicker } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import './DateTimePicker.scss';

/** @param {import('rsuite').DatePickerProps & {hasError?: boolean}} param0 */
const DateTimePicker = ({
    hasError,
    disabled,
    ...props
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const { DateTimeFormat: dateTimeFormat } = JSON.parse(sessionStorage.getItem('jwtUserInfo') || '{}');

    let defaultDateTimeFormat = dateTimeFormat ? `${dateTimeFormat.LongDateFormat} ${dateTimeFormat.TimeFormat}` : 'yyyy-MM-dd HH:mm aa';
    const isMeridiem = !defaultDateTimeFormat.includes('aa') && defaultDateTimeFormat.includes('a');
    if (isMeridiem) {
        defaultDateTimeFormat = defaultDateTimeFormat.replace('a', 'aa');
    }

    const handleOpenMenu = () => {
        if (disabled) return;
        setIsMenuOpen(!isMenuOpen);
    }

    const calendarIcon = React.forwardRef((iconProps, ref) => {
        return (
            <FontAwesomeIcon
                className="date-time-picker-caret-icon"
                icon={faCalendarDays} 
                {...iconProps} 
                ref={ref}
            />)
    });

    const chevronIcon = isMenuOpen ? faChevronUp : faChevronDown;

    return (
        <div className={`core--date-time-picker ${hasError ? 'core--date-time-picker-error' : ''}`}>
            <DatePicker
                menuClassName="core--date-time-picker-menu"
                format={defaultDateTimeFormat}
                caretAs={calendarIcon}
                showHeader={false}
                showMeridiem={isMeridiem}
                onOpen={() => setIsMenuOpen(true)}
                onOk={() => setIsMenuOpen(false)}
                onExit={() => setIsMenuOpen(false)}
                open={isMenuOpen}
                disabled={disabled}
                {...props}
            />
            <div className="date-time-picker-chevron-icon-wrapper" onClick={handleOpenMenu}>
                <FontAwesomeIcon icon={chevronIcon} />
            </div>
            {isMenuOpen && (
                <div
                    className="core--date-time-picker-overlay"
                    onClick={() => setIsMenuOpen(false)}
                >
                </div>
            )}
        </div>
    );
};

export default DateTimePicker;
